import { useEffect } from 'react';

const SITE_ORIGIN = 'https://easydroptaxi.com';

const upsertMeta = (attr, key, content) => {
  if (!content) return null;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  const created = !el;
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  const previous = el.getAttribute('content');
  el.setAttribute('content', content);
  return { el, created, previous, valueAttr: 'content' };
};

const upsertLink = (rel, href) => {
  let el = document.head.querySelector(`link[rel="${rel}"]`);
  const created = !el;
  if (!el) {
    el = document.createElement('link');
    el.setAttribute('rel', rel);
    document.head.appendChild(el);
  }
  const previous = el.getAttribute('href');
  el.setAttribute('href', href);
  return { el, created, previous, valueAttr: 'href' };
};

const SeoHead = ({ title, description, path, image, jsonLd = [] }) => {
  useEffect(() => {
    const prevTitle = document.title;
    document.title = title;
    const absoluteUrl = `${SITE_ORIGIN}${path}`;
    const ogImage = image
      ? (image.startsWith('http') ? image : `${SITE_ORIGIN}${image}`)
      : '';

    const managed = [
      upsertMeta('name', 'description', description),
      upsertMeta('property', 'og:title', title),
      upsertMeta('property', 'og:description', description),
      upsertMeta('property', 'og:type', 'website'),
      upsertMeta('property', 'og:url', absoluteUrl),
      upsertMeta('property', 'og:image', ogImage),
      upsertMeta('name', 'twitter:card', ogImage ? 'summary_large_image' : 'summary'),
      upsertMeta('name', 'twitter:title', title),
      upsertMeta('name', 'twitter:description', description),
      upsertMeta('name', 'twitter:image', ogImage),
      upsertLink('canonical', absoluteUrl),
    ].filter(Boolean);

    // Drop static shell page schema before client injects the live copy,
    // so crawlers that execute JS never see duplicate FAQ/breadcrumb blocks.
    // Leave the sitewide TaxiService in index.html (no data-seo-shell-jsonld).
    const shellJsonLd = jsonLd && (Array.isArray(jsonLd) ? jsonLd : [jsonLd]).filter(Boolean).length
      ? Array.from(
        document.head.querySelectorAll(
          'script[type="application/ld+json"][data-seo-shell-jsonld="true"]',
        ),
      )
      : [];
    shellJsonLd.forEach((el) => el.remove());

    const scripts = (Array.isArray(jsonLd) ? jsonLd : [jsonLd]).filter(Boolean).map((data, index) => {
      const script = document.createElement('script');
      script.type = 'application/ld+json';
      script.dataset.seoJsonld = 'true';
      script.id = `route-seo-jsonld-${index}`;
      script.text = JSON.stringify(data);
      document.head.appendChild(script);
      return script;
    });

    return () => {
      document.title = prevTitle;
      managed.forEach((item) => {
        if (item.created) {
          item.el.remove();
        } else if (item.previous != null) {
          item.el.setAttribute(item.valueAttr, item.previous);
        }
      });
      scripts.forEach((script) => script.remove());
    };
  }, [title, description, path, image, jsonLd]);

  return null;
};

export default SeoHead;
